// directives/clickOutside.js
export default {
  bind(el, binding) {
    el.clickOutsideEvent = function(event) {
      // Check if click was outside the element
      if (!(el === event.target || el.contains(event.target))) {
        binding.value(event); // call the provided method
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  }
};
